import React, { createContext, useContext, useEffect, useState, useMemo, } from "react";
import { ResponsiveBar } from "@nivo/bar";
import { ResponsiveLine } from "@nivo/line";
import { repeatEffect, settingsConfig, toFormatedDateMMDDHHmm, } from "utils/commonFunc";
import ApiService from "services/ApiService";
import { defaultChartProps } from "pages/components/CustomDashboardChart";
import { dashboardTheme } from "utils/nivoConfig";
import { useTrafficInOutTab } from "pages/dashboard/RoadTrafficViewD";

const TrafficTotalContext = createContext(null);
const colors = ["var(--pr-50)", "var(--alert-50)"]; //월 평균(파랑), 금일(빨강)

export function SwItsSgnalTotalProvider({ children }) {
  const [currentData, setCurrentData] = useState();

  useEffect(() => {
    return repeatEffect(async () => {
      const response = await ApiService.get(
        "newdashboard/sgnloprt/GetHourSnstvSignal"
      );
      if (response.status === 200) {
        const data = response.data;
        const ergrCntSeries = { id: "생략횟수", data: [] };
        const perGrnTmSeries = { id: "녹색시간비율", data: [] };
        const aggregatedData = {};

        // 시간별 데이터 집계
        data.rows.forEach((p) => {
          if (!aggregatedData[p.hh]) {
            aggregatedData[p.hh] = { ergrCnt: 0, perGrnTm: 0 };
          }
          aggregatedData[p.hh].ergrCnt += p.ergrCnt;
          aggregatedData[p.hh].perGrnTm += p.perGrnTm;
        });

        // 집계된 데이터를 차트 데이터 형식으로 변환
        Object.keys(aggregatedData).forEach((hour) => {
          ergrCntSeries.data.push({
            x: hour,
            y: aggregatedData[hour].ergrCnt === 0 ? null : aggregatedData[hour].ergrCnt,
          });
          perGrnTmSeries.data.push({
            x: hour,
            y: aggregatedData[hour].perGrnTm === 0 ? null : aggregatedData[hour].perGrnTm,
          });
        });

        // 총합 계산
        const totalErgrCnt = data.rows.reduce((sum, row) => sum + row.ergrCnt, 0);
        const avgPerGrnTm = data.rows.reduce((sum, row) => sum + row.perGrnTm, 0) / data.rows.length;

        setCurrentData({
          chartData: [ergrCntSeries, perGrnTmSeries],
          updateTime: data.updateTime,
          unit: "건/시",
          todayLabel: `생략횟수`,
          todayValue: totalErgrCnt.toLocaleString(),
          monthValue: avgPerGrnTm.toFixed(1),
          changeLabel: "녹색시간비율(%)",
          changeValue: `${avgPerGrnTm.toFixed(1)}`,
          // 필요 없는 값들은 기본값으로 설정
          todayIn: 0,
          todayOut: 0,
          rangeIn: 0,
          rangeOut: 0,
        });
      }
    }, settingsConfig().contentUpdateDelaySec);
  }, []);

  return (
    <TrafficTotalContext.Provider value={currentData}>
      {children}
    </TrafficTotalContext.Provider>
  );
}


// const CustomRangeDotAndLineLayer = ({ bars, data }) => {
//   // 유효한 데이터 포인트만 필터링
//   const validBars = bars.filter(bar => {
//     const hourData = data.find(d => d.hour === bar.data.indexValue);
//     return hourData && hourData.perGrnTm && hourData.perGrnTm > 0;
//   });

//   // 정렬 (x 좌표 기준)
//   validBars.sort((a, b) => a.x - b.x);

//   // 선을 그리기 위한 포인트 생성
//   const linePoints = validBars.map(bar => {
//     const hourData = data.find(d => d.hour === bar.data.indexValue);
//     const ratio = hourData.perGrnTm / 20; // 백분율을 비율로 변환
//     console.log('ratio :::',ratio)
//     const dotY = bar.y + bar.height * (1 - ratio);

//     return {
//       x: bar.x + bar.width / 2, // 각 바의 중앙 x 좌표
//       y: dotY,
//       key: bar.key
//     };
//   });

//   // 연결된 선을 위한 path 문자열 생성
//   const pathData = linePoints.length
//     ? `M ${linePoints.map(point => `${point.x},${point.y}`).join(' L ')}`
//     : '';

//   return (
//     <>
//       {/* 연속된 선 그리기 */}
//       {linePoints.length > 1 && (
//         <path
//           d={pathData}
//           fill="none"
//           stroke="#FFD700"
//           strokeWidth={3}
//           strokeLinejoin="round"
//           strokeLinecap="round"
//         />
//       )}

//       {/* 각 데이터 포인트마다 원 그리기 */}
//       {linePoints.map(point => (
//         <circle
//           key={`dot-${point.key}`}
//           cx={point.x}
//           cy={point.y}
//           r={5}
//           fill="#FFD700"
//           stroke="#FFD700"
//           strokeWidth={2}
//         />
//       ))}
//     </>
//   );
// };

// const CustomRangeDotAndLineLayer = ({ bars, data }) => {
//   const validBars = bars.filter(bar => {
//     const hourData = data.find(d => d.hour === bar.data.indexValue);
//     return hourData && hourData.perGrnTm && hourData.perGrnTm > 0;
//   });

//   validBars.sort((a, b) => a.x - b.x);

//   const linePoints = validBars.map(bar => {
//     const hourData = data.find(d => d.hour === bar.data.indexValue);
//     const ratio = hourData.perGrnTm / 30; // 100으로 나눠야 백분율 대응
//     const dotY = bar.y + bar.height * (1 - ratio);

//     return {
//       x: bar.x + bar.width / 2,
//       y: dotY,
//       label: `${hourData.perGrnTm.toFixed(1)}%`,
//       key: bar.key,
//     };
//   });

//   const pathData = linePoints.length
//     ? `M ${linePoints.map(point => `${point.x},${point.y}`).join(' L ')}`
//     : '';

//   return (
//     <>
//       {/* 선 */}
//       {linePoints.length > 1 && (
//         <path
//           d={pathData}
//           fill="none"
//           stroke="#FFD700"
//           strokeWidth={3}
//           strokeLinejoin="round"
//           strokeLinecap="round"
//         />
//       )}

//       {/* 점 + 퍼센트 텍스트 */}
//       {linePoints.map(point => (
//         <g key={`dot-${point.key}`}>
//           <circle
//             cx={point.x}
//             cy={point.y}
//             r={5}
//             fill="#FFD700"
//             stroke="#fff"
//             strokeWidth={1.5}
//           />
//           <text
//             x={point.x}
//             y={point.y - 30}
//             textAnchor="middle"
//             fill="#FFD700"
//             fontSize={10}
//             fontWeight={200}
//           >
//             {point.label}
//           </text>
//         </g>
//       ))}
//     </>
//   );
// };

// const CustomRangeDotAndLineLayer = ({ bars, data }) => {
//   const validBars = bars.filter(bar => {
//     const hourData = data.find(d => d.hour === bar.data.indexValue);
//     return hourData && hourData.perGrnTm && hourData.perGrnTm > 0;
//   });

//   validBars.sort((a, b) => a.x - b.x);

//   const linePoints = validBars.map(bar => {
//     const hourData = data.find(d => d.hour === bar.data.indexValue);
//     const ratio = hourData.perGrnTm / 30; // 100으로 나눠야 백분율 대응
//     const dotY = bar.y + bar.height * (1 - ratio);

//     return {
//       x: bar.x + bar.width / 2,
//       y: dotY,
//       key: bar.key,
//     };
//   });

//   const pathData = linePoints.length
//     ? `M ${linePoints.map(point => `${point.x},${point.y}`).join(' L ')}`
//     : '';

//   return (
//     <>
//       {/* 선 */}
//       {linePoints.length > 1 && (
//         <path
//           d={pathData}
//           fill="none"
//           stroke="#FFD700"
//           strokeWidth={3}
//           strokeLinejoin="round"
//           strokeLinecap="round"
//         />
//       )}

//       {/* 점만 표시하고 텍스트는 제거 */}
//       {linePoints.map(point => (
//         <g key={`dot-${point.key}`}>
//           <circle
//             cx={point.x}
//             cy={point.y}
//             r={5}
//             fill="#FFD700"
//             stroke="#fff"
//             strokeWidth={1.5}
//           />
//         </g>
//       ))}
//     </>
//   );
// };
// const CustomRangeDotAndLineLayer = ({ bars, data, normalizeFactor }) => {
//   const validBars = bars.filter(bar => {
//     const hourData = data.find(d => d.hour === bar.data.indexValue);
//     return hourData && hourData.perGrnTm && hourData.perGrnTm > 0;
//   });

//   validBars.sort((a, b) => a.x - b.x);

//   const linePoints = validBars.map(bar => {
//     const hourData = data.find(d => d.hour === bar.data.indexValue);
//     // 녹색시간비율 값을 정규화하여 생략횟수 스케일에 맞춤
//     const normalizedValue = hourData.perGrnTm * normalizeFactor;
    
//     // 정규화된 값에 기반한 Y 위치 계산
//     const y = bar.y - (normalizedValue / (bar.height + bar.y));

//     return {
//       x: bar.x + bar.width / 2,
//       y: y,
//       key: bar.key,
//     };
//   });

//   const pathData = linePoints.length
//     ? `M ${linePoints.map(point => `${point.x},${point.y}`).join(' L ')}`
//     : '';

//   return (
//     <>
//       {/* 선 */}
//       {linePoints.length > 1 && (
//         <path
//           d={pathData}
//           fill="none"
//           stroke="#FFD700"
//           strokeWidth={3}
//           strokeLinejoin="round"
//           strokeLinecap="round"
//         />
//       )}

//       {/* 점 */}
//       {linePoints.map(point => (
//         <g key={`dot-${point.key}`}>
//           <circle
//             cx={point.x}
//             cy={point.y}
//             r={5}
//             fill="#FFD700"
//             stroke="#fff"
//             strokeWidth={1.5}
//           />
//         </g>
//       ))}
//     </>
//   );
// };

const CustomRangeDotAndLineLayer = ({ bars, data, maxY, maxPerGrnTm }) => {
  const validBars = bars.filter(bar => {
    const hourData = data.find(d => d.hour === bar.data.indexValue);
    return hourData && hourData.perGrnTm && hourData.perGrnTm > 0;
  });

  validBars.sort((a, b) => a.x - b.x);

  const linePoints = validBars.map(bar => {
    const hourData = data.find(d => d.hour === bar.data.indexValue);
    const perGrnTm = hourData.perGrnTm;

    const chartBottomY = bar.y + bar.height;

    // bar chart와 같은 기준으로 y위치 계산: 위로 갈수록 작아짐
    const yRatio = perGrnTm / maxPerGrnTm;
    const y = chartBottomY - yRatio * (chartBottomY - 0); // top은 0

    return {
      x: bar.x + bar.width / 2,
      y,
      key: bar.key,
    };
  });

  const pathData = linePoints.length
    ? `M ${linePoints.map(point => `${point.x},${point.y}`).join(' L ')}`
    : '';

  return (
    <>
      {/* 선 */}
      {linePoints.length > 1 && (
        <path
          d={pathData}
          fill="none"
          stroke="#FFD700"
          strokeWidth={3}
          strokeLinejoin="round"
          strokeLinecap="round"
        />
      )}

      {/* 점 */}
      {linePoints.map(point => (
        <g key={`dot-${point.key}`}>
          <circle
            cx={point.x}
            cy={point.y}
            r={5}
            fill="#FFD700"
            stroke="#fff"
            strokeWidth={1.5}
          />
        </g>
      ))}
    </>
  );
};

// export function SwItsTrafficSgnlBarChart() {
//   const currentData = useContext(TrafficTotalContext);
//   const processedData = useMemo(() => {
//     if (!currentData || !currentData.chartData) return [];

//     const hourlyData = {};

//     currentData.chartData.forEach((series) => {
//       const isErgrCnt = series.id === "생략횟수"; // id로 비상감지 데이터인지 구분
//       series.data.forEach((point) => {
//         const hour = point.x;
//         const value = point.y ?? 0;

//         if (!hourlyData[hour]) {
//           hourlyData[hour] = {
//             hour: `${hour}`,
//             ergrCnt: 0,
//             perGrnTm: 0,
//           };
//         }

//         if (isErgrCnt) {
//           hourlyData[hour].ergrCnt = value;
//         } else {
//           hourlyData[hour].perGrnTm = value;
//         }
//       });
//     });

//     return Object.values(hourlyData).sort(
//       (a, b) => parseInt(a.hour) - parseInt(b.hour)
//     );
//   }, [currentData]);
//    const filteredData = useMemo(() => {
//     return processedData.filter((item) => item.ergrCnt > 0);
//   }, [processedData]);

//   const { minY, maxY, yTicks, maxPerGrnTm, perGrnTmTicks, normalizeFactor } = useMemo(() => {
//     const allY = filteredData.map(d => d.ergrCnt).filter(val => val > 0);
//     const allPerGrnTm = filteredData.map(d => d.perGrnTm).filter(val => val > 0);

//     const min = 0;
//     const rawMax = allY.length ? Math.max(...allY) : 500;

//     const magnitude = Math.pow(10, Math.floor(Math.log10(rawMax)));
//     const max = Math.ceil(rawMax / magnitude) * magnitude;

//     // 눈금 간격 계산 (균등하게 6개 구간으로 나누기)
//     const step = max / 5;
//     const ticks = Array.from({ length: 6 }, (_, i) => Math.round(i * step));
    
//     // 녹색시간비율 최대값 계산 (최대 30% 정도로 설정)
//     const maxPer = allPerGrnTm.length ? Math.max(...allPerGrnTm) : 50;
//     const roundedMaxPer = Math.ceil(maxPer / 5) * 5; // 5단위로 올림
    
//     // 녹색시간비율 틱 생성 (5, 10, 15, 20, 25, ...)
//     const perTicks = Array.from(
//       { length: roundedMaxPer / 5 + 1 }, 
//       (_, i) => i * 5
//     );
    
//     // 정규화 계수 계산 (생략횟수와 녹색시간비율 간의 스케일 변환 계수)
//     const normFactor = max / roundedMaxPer;

//     return { 
//       minY: min, 
//       maxY: max, 
//       yTicks: ticks,
//       maxPerGrnTm: roundedMaxPer,
//       perGrnTmTicks: perTicks,
//       normalizeFactor: normFactor
//     };
//   }, [filteredData]);
  
//   // 정규화된 데이터 생성 - perGrnTm 값을 생략횟수 스케일로 변환
//   const normalizedData = useMemo(() => {
//     return filteredData.map(item => ({
//       ...item,
//       normalizedPerGrnTm: item.perGrnTm * normalizeFactor
//     }));
//   }, [filteredData, normalizeFactor]);

//   if (!filteredData.length) return <div>데이터가 없습니다.</div>;

//   return (
//     <div style={{ width: "100%", height: "620px" }}>
//       <ResponsiveBar
//         data={normalizedData}
//         keys={["ergrCnt"]}
//         indexBy="hour"
//         padding={0.3}
//         colors={["var(--pr-50)"]}
//         valueScale={{ type: "linear", min: minY, max: maxY }}
//         margin={{ top: 60, right: 75, bottom: 50, left: 75 }}
      
//         axisLeft={{
//           tickValues: yTicks,
//           format: (value) => `${value}`,
//           tickSize: 5,
//           tickPadding: 10,
//           tickRotation: 0,
//           tickColor: "#fff",
//           legend: "생략횟수",
//           legendPosition: "middle",
//           legendOffset: -60,
//         }}
//         axisRight={{
//           // 같은 그리드 위치에 다른 값으로 표시하기 위해 변환된 값 사용
//           tickValues: perGrnTmTicks.map(v => v * normalizeFactor),
//           format: (value) => `${Math.round(value / normalizeFactor)}%`,
//           tickSize: 5,
//           tickPadding: 10,
//           tickRotation: 0,
//           tickColor: "#FFD700",
//           legend: "녹색시간비율",
//           legendPosition: "middle",
//           legendOffset: 60,
//         }}
//         axisBottom={{
//           tickSize: 0,
//           tickPadding: 10,
//           tickColor: "#fff",
//           format: (value) => `${value}시`,
//           legend: "시간대",
//           legendPosition: "middle",
//           legendOffset: 40,
//         }}
//         enableGridY={true}
//         gridYValues={yTicks}
//         labelSkipWidth={999}
//         theme={{
//           axis: {
//             ticks: {
//               text: {
//                 fill: "#fff",
//                 fontSize: 25,
//               },
//             },
//           },
//           grid: {
//             line: {
//               stroke: "#fff",
//               strokeOpacity: 0.2,
//             },
//           },
//           legends: {
//             text: {
//               fill: "#fff",
//               fontSize: 25,
//               fontWeight: 600,
//             },
//           },
//         }}
//         tooltip={({ id, value, indexValue, data }) => (
//           <div
//             style={{
//               background: "#333",
//               padding: "12px",
//               color: "white",
//               fontSize: "14px",
//               borderRadius: "4px",
//             }}
//           >
//             <div>{indexValue}시</div>
//             <div>생략횟수: {value.toLocaleString()} 건</div>
//             {data.perGrnTm > 0 && (
//               <div>녹색시간비율: {data.perGrnTm.toFixed(1)}%</div>
//             )}
//           </div>
//         )}
//         legends={[
//           {
//             dataFrom: "keys",
//             anchor: "top-right",
//             direction: "row",
//             translateY: -40,
//             translateX: -120,
//             itemsSpacing: 50,
//             itemWidth: 80,
//             itemHeight: 20,
//             itemDirection: "left-to-right",
//             symbolSize: 12,
//             symbolShape: "square",
//             effects: [
//               {
//                 on: "hover",
//                 style: {
//                   itemTextColor: "#fff",
//                 },
//               },
//             ],
//             data: [
//               { id: "ergrCnt", label: "생략횟수", color: "var(--pr-50)" },
//               { id: "perGrnTm", label: "녹색시간비율(%)", color: "#FFD700" },
//             ],
//           },
//         ]}
//         // layers={[
//         //   "grid",
//         //   "axes",
//         //   "bars",
//         //   ({ bars }) => (
//         //     <CustomRangeDotAndLineLayer 
//         //       bars={bars} 
//         //       data={normalizedData} 
//         //       normalizeFactor={normalizeFactor}
//         //     />
//         //   ),
//         //   "markers",
//         //   "legends",
//         // ]}
//         layers={[
//   "grid",
//   "axes",
//   "bars",
//   ({ bars }) => (
//     <CustomRangeDotAndLineLayer 
//       bars={bars} 
//       data={normalizedData} 
//       maxY={maxY}
//       maxPerGrnTm={maxPerGrnTm}
//     />
//   ),
//   "markers",
//   "legends",
// ]}
//         borderRadius={2}
//         isInteractive={true}
//         animate={true}
//       />
//     </div>
//   );
// }


export function SwItsTrafficSgnlBarChart() {
  const currentData = useContext(TrafficTotalContext);
  const processedData = useMemo(() => {
    if (!currentData || !currentData.chartData) return [];

    const hourlyData = {};

    currentData.chartData.forEach((series) => {
      const isErgrCnt = series.id === "생략횟수";
      series.data.forEach((point) => {
        const hour = point.x;
        const value = point.y ?? 0;

        if (!hourlyData[hour]) {
          hourlyData[hour] = {
            hour: `${hour}`,
            ergrCnt: 0,
            perGrnTm: 0,
          };
        }

        if (isErgrCnt) {
          hourlyData[hour].ergrCnt = value;
        } else {
          hourlyData[hour].perGrnTm = value;
        }
      });
    });

    return Object.values(hourlyData).sort(
      (a, b) => parseInt(a.hour) - parseInt(b.hour)
    );
  }, [currentData]);

  const filteredData = useMemo(() => {
    return processedData.filter((item) => item.ergrCnt > 0);
  }, [processedData]);

  const { minY, maxY, yTicks, maxPerGrnTm, perGrnTmTicks, normalizeFactor } = useMemo(() => {
    const allY = filteredData.map(d => d.ergrCnt).filter(val => val > 0);
    const allPerGrnTm = filteredData.map(d => d.perGrnTm).filter(val => val > 0);

    const min = 0;
    const rawMax = allY.length ? Math.max(...allY) : 500;
    const magnitude = Math.pow(10, Math.floor(Math.log10(rawMax)));
    const max = Math.ceil(rawMax / magnitude) * magnitude;

    const step = max / 5;
    const ticks = Array.from({ length: 6 }, (_, i) => Math.round(i * step));

    const maxPer = allPerGrnTm.length ? Math.max(...allPerGrnTm) : 50;
    const roundedMaxPer = Math.ceil(maxPer / 5) * 5;
    const perTicks = Array.from({ length: roundedMaxPer / 5 + 1 }, (_, i) => i * 5);

    const normFactor = max / roundedMaxPer;

    const adjustedMaxY = Math.max(
      max,
      Math.ceil((roundedMaxPer * normFactor) / 10) * 10
    );

    return {
      minY: min,
      maxY: adjustedMaxY,
      yTicks: Array.from({ length: 6 }, (_, i) => Math.round((adjustedMaxY / 5) * i)),
      maxPerGrnTm: roundedMaxPer,
      perGrnTmTicks: perTicks,
      normalizeFactor: normFactor
    };
  }, [filteredData]);

  const normalizedData = useMemo(() => {
    return filteredData.map(item => ({
      ...item,
      normalizedPerGrnTm: item.perGrnTm * normalizeFactor
    }));
  }, [filteredData, normalizeFactor]);

  if (!filteredData.length) return <div>데이터가 없습니다.</div>;

  return (
    <div style={{ width: "100%", height: "620px" }}>
      <ResponsiveBar
        data={normalizedData}
        keys={["ergrCnt"]}
        indexBy="hour"
        padding={0.3}
        colors={["var(--pr-50)"]}
        valueScale={{ type: "linear", min: minY, max: maxY }}
        margin={{ top: 60, right: 75, bottom: 50, left: 75 }}
        axisLeft={{
          tickValues: yTicks,
          format: (value) => `${value}`,
          tickSize: 5,
          tickPadding: 10,
          tickRotation: 0,
          tickColor: "#fff",
          legend: "생략횟수",
          legendPosition: "middle",
          legendOffset: -60,
        }}
        axisRight={{
          tickValues: perGrnTmTicks
            .map((v) => v * normalizeFactor)
            .filter((val) => val <= maxY),
          format: (value) => `${Math.round(value / normalizeFactor)}%`,
          tickSize: 5,
          tickPadding: 10,
          tickRotation: 0,
          tickColor: "#FFD700",
          legend: "녹색시간비율",
          legendPosition: "middle",
          legendOffset: 60,
        }}
        axisBottom={{
          tickSize: 0,
          tickPadding: 10,
          tickColor: "#fff",
          format: (value) => `${value}시`,
          legend: "시간대",
          legendPosition: "middle",
          legendOffset: 40,
        }}
        enableGridY={true}
        gridYValues={yTicks}
        labelSkipWidth={999}
        theme={{
          axis: {
            ticks: {
              text: {
                fill: "#fff",
                fontSize: 25,
              },
            },
          },
          grid: {
            line: {
              stroke: "#fff",
              strokeOpacity: 0.2,
            },
          },
          legends: {
            text: {
              fill: "#fff",
              fontSize: 25,
              fontWeight: 600,
            },
          },
        }}
        tooltip={({ id, value, indexValue, data }) => (
          <div
            style={{
              background: "#333",
              padding: "12px",
              color: "white",
              fontSize: "14px",
              borderRadius: "4px",
            }}
          >
            <div>{indexValue}시</div>
            <div>생략횟수: {value.toLocaleString()} 건</div>
            {data.perGrnTm > 0 && (
              <div>녹색시간비율: {data.perGrnTm.toFixed(1)}%</div>
            )}
          </div>
        )}
        legends={[
          {
            dataFrom: "keys",
            anchor: "top-right",
            direction: "row",
            translateY: -40,
            translateX: -120,
            itemsSpacing: 50,
            itemWidth: 80,
            itemHeight: 20,
            itemDirection: "left-to-right",
            symbolSize: 12,
            symbolShape: "square",
            effects: [
              {
                on: "hover",
                style: {
                  itemTextColor: "#fff",
                },
              },
            ],
            data: [
              { id: "ergrCnt", label: "생략횟수", color: "var(--pr-50)" },
              { id: "perGrnTm", label: "녹색시간비율(%)", color: "#FFD700" },
            ],
          },
        ]}
        layers={[
          "grid",
          "axes",
          "bars",
          ({ bars }) => (
            <CustomRangeDotAndLineLayer
              bars={bars}
              data={normalizedData}
              maxY={maxY}
              maxPerGrnTm={maxPerGrnTm}
            />
          ),
          "markers",
          "legends",
        ]}
        borderRadius={2}
        isInteractive={true}
        animate={true}
      />
    </div>
  );
}
